import { getPeriodGranularity } from "../constants/invoicePeriod";
import { INVOICE_LOCALISATION } from "../constants/localisation";
import type {
  ApiInvoiceRow,
  InvoiceDetail,
  InvoiceInsurerOption,
  InvoiceLineItem,
  InvoiceParty,
  InvoicePeriodGranularity,
  InvoicePeriodOption,
  InvoiceSummaryData,
  InvoiceTaxLine,
  InvoiceTaxSplit,
} from "../types";

export const INVOICE_MOCK_ROWS: ApiInvoiceRow[] = [
  {
    id: 3,
    invoice_no: "INV-0002",
    insurer_id: 1,
    insurer: "American International Group, Inc.",
    period_from: "2026-05-01T00:00:00+00:00",
    period_to: "2026-05-31T00:00:00+00:00",
    invoice_amount: 5.04,
    total_collected: 5.04,
    outstanding: 0,
    status: "PAID",
    due_date: "2026-06-13T00:00:00+00:00",
    policy_id: 140,
    policy_no: "836246774",
    product: "American International Group, Inc.-Silver Plan",
    customer: "sandesh test datir",
    premium: 252.0,
    rate: 10.0,
    commission: 5.04,
    tax_type: 0.91,
    issue_date: "2026-05-13T00:00:00+00:00",
  },
  {
    id: 4,
    invoice_no: "INV-0003",
    insurer_id: 1,
    insurer: "American International Group, Inc.",
    period_from: "2026-06-01T00:00:00+00:00",
    period_to: "2026-06-30T00:00:00+00:00",
    invoice_amount: 18.75,
    total_collected: 10.0,
    outstanding: 8.75,
    status: "INVOICED",
    due_date: "2026-07-15T00:00:00+00:00",
    policy_id: 152,
    policy_no: "836246812",
    product: "American International Group, Inc.-Gold Plan",
    customer: "rahul verma",
    premium: 625.0,
    rate: 3.0,
    commission: 18.75,
    tax_type: 3.38,
    issue_date: "2026-06-04T00:00:00+00:00",
  },
  {
    id: 5,
    invoice_no: "INV-0004",
    insurer_id: 2,
    insurer: "Sukoon Insurance",
    period_from: "2026-06-01T00:00:00+00:00",
    period_to: "2026-06-30T00:00:00+00:00",
    invoice_amount: 142.5,
    total_collected: 0,
    outstanding: 142.5,
    status: "UNBILLED",
    due_date: "2026-07-20T00:00:00+00:00",
    policy_id: 161,
    policy_no: "SUK-990112",
    product: "Sukoon Insurance-Comprehensive Motor",
    customer: "aisha khan",
    premium: 2850.0,
    rate: 5.0,
    commission: 142.5,
    tax_type: 25.65,
    issue_date: "2026-06-11T00:00:00+00:00",
  },
  {
    id: 6,
    invoice_no: "INV-0005",
    insurer_id: 3,
    insurer: "GIG Gulf",
    period_from: "2026-05-01T00:00:00+00:00",
    period_to: "2026-06-30T00:00:00+00:00",
    invoice_amount: 96.0,
    total_collected: 96.0,
    outstanding: 0,
    status: "RECONCILED",
    due_date: "2026-07-05T00:00:00+00:00",
    policy_id: 168,
    policy_no: "GIG-445120",
    product: "GIG Gulf-Third Party Motor",
    customer: "mohammed farooq",
    premium: 1200.0,
    rate: 8.0,
    commission: 96.0,
    tax_type: 17.28,
    issue_date: "2026-05-27T00:00:00+00:00",
  },
  {
    id: 7,
    invoice_no: "INV-0006",
    insurer_id: 2,
    insurer: "Sukoon Insurance",
    period_from: "2026-07-01T00:00:00+00:00",
    period_to: "2026-07-31T00:00:00+00:00",
    invoice_amount: 61.2,
    total_collected: 30.0,
    outstanding: 31.2,
    status: "INVOICED",
    due_date: "2026-08-14T00:00:00+00:00",
    policy_id: 174,
    policy_no: "SUK-990455",
    product: "Sukoon Insurance-Travel Worldwide",
    customer: "neha sharma",
    premium: 612.0,
    rate: 10.0,
    commission: 61.2,
    tax_type: 11.02,
    issue_date: "2026-07-02T00:00:00+00:00",
  },
  {
    id: 8,
    invoice_no: "INV-0007",
    insurer_id: 4,
    insurer: "Liva Insurance",
    period_from: "2026-07-01T00:00:00+00:00",
    period_to: "2026-07-31T00:00:00+00:00",
    invoice_amount: 210.4,
    total_collected: 210.4,
    outstanding: 0,
    status: "PAID",
    due_date: "2026-08-10T00:00:00+00:00",
    policy_id: 181,
    policy_no: "LIV-778201",
    product: "Liva Insurance-Family Health",
    customer: "karan malhotra",
    premium: 2630.0,
    rate: 8.0,
    commission: 210.4,
    tax_type: 37.87,
    issue_date: "2026-07-09T00:00:00+00:00",
  },
  {
    id: 9,
    invoice_no: "INV-0008",
    insurer_id: 3,
    insurer: "GIG Gulf",
    period_from: "2026-08-01T00:00:00+00:00",
    period_to: "2026-08-31T00:00:00+00:00",
    invoice_amount: 45.9,
    total_collected: 0,
    outstanding: 45.9,
    status: "UNBILLED",
    due_date: "2026-09-12T00:00:00+00:00",
    policy_id: 190,
    policy_no: "GIG-445988",
    product: "GIG Gulf-Travel Schengen",
    customer: "sneha iyer",
    premium: 510.0,
    rate: 9.0,
    commission: 45.9,
    tax_type: 8.26,
    issue_date: "2026-08-03T00:00:00+00:00",
  },
  {
    id: 10,
    invoice_no: "INV-0009",
    insurer_id: 1,
    insurer: "American International Group, Inc.",
    period_from: "2026-08-01T00:00:00+00:00",
    period_to: "2026-08-31T00:00:00+00:00",
    invoice_amount: 132.3,
    total_collected: 100.0,
    outstanding: 32.3,
    status: "INVOICED",
    due_date: "2026-09-18T00:00:00+00:00",
    policy_id: 197,
    policy_no: "836247033",
    product: "American International Group, Inc.-Platinum Plan",
    customer: "vikram nair",
    premium: 1890.0,
    rate: 7.0,
    commission: 132.3,
    tax_type: 23.81,
    issue_date: "2026-08-06T00:00:00+00:00",
  },
  {
    id: 11,
    invoice_no: "INV-0010",
    insurer_id: 5,
    insurer: "RAK Insurance",
    period_from: "2026-08-01T00:00:00+00:00",
    period_to: "2026-09-30T00:00:00+00:00",
    invoice_amount: 78.0,
    total_collected: 78.0,
    outstanding: 0,
    status: "RECONCILED",
    due_date: "2026-10-05T00:00:00+00:00",
    policy_id: 203,
    policy_no: "RAK-118743",
    product: "RAK Insurance-Home Contents",
    customer: "fatima al mansoori",
    premium: 1560.0,
    rate: 5.0,
    commission: 78.0,
    tax_type: 14.04,
    issue_date: "2026-08-21T00:00:00+00:00",
  },
  {
    id: 12,
    invoice_no: "INV-0011",
    insurer_id: 4,
    insurer: "Liva Insurance",
    period_from: "2026-09-01T00:00:00+00:00",
    period_to: "2026-09-30T00:00:00+00:00",
    invoice_amount: 24.6,
    total_collected: 0,
    outstanding: 24.6,
    status: "UNBILLED",
    due_date: "2026-10-16T00:00:00+00:00",
    policy_id: 211,
    policy_no: "LIV-778655",
    product: "Liva Insurance-Individual Health",
    customer: "arjun desai",
    premium: 410.0,
    rate: 6.0,
    commission: 24.6,
    tax_type: 4.43,
    issue_date: "2026-09-02T00:00:00+00:00",
  },
  {
    id: 13,
    invoice_no: "INV-0012",
    insurer_id: 2,
    insurer: "Sukoon Insurance",
    period_from: "2026-09-01T00:00:00+00:00",
    period_to: "2026-09-30T00:00:00+00:00",
    invoice_amount: 315.0,
    total_collected: 200.0,
    outstanding: 115.0,
    status: "INVOICED",
    due_date: "2026-10-22T00:00:00+00:00",
    policy_id: 218,
    policy_no: "SUK-991002",
    product: "Sukoon Insurance-Comprehensive Motor",
    customer: "priya rane",
    premium: 4500.0,
    rate: 7.0,
    commission: 315.0,
    tax_type: 56.7,
    issue_date: "2026-09-08T00:00:00+00:00",
  },
  {
    id: 14,
    invoice_no: "INV-0013",
    insurer_id: 5,
    insurer: "RAK Insurance",
    period_from: "2026-10-01T00:00:00+00:00",
    period_to: "2026-10-31T00:00:00+00:00",
    invoice_amount: 52.8,
    total_collected: 52.8,
    outstanding: 0,
    status: "PAID",
    due_date: "2026-11-09T00:00:00+00:00",
    policy_id: 224,
    policy_no: "RAK-119008",
    product: "RAK Insurance-Travel Single Trip",
    customer: "daniel dsouza",
    premium: 660.0,
    rate: 8.0,
    commission: 52.8,
    tax_type: 9.5,
    issue_date: "2026-10-04T00:00:00+00:00",
  },
];

export const getInvoiceRows = (): ApiInvoiceRow[] => INVOICE_MOCK_ROWS;

export const getInvoiceSummary = (
  rows: ApiInvoiceRow[] = INVOICE_MOCK_ROWS
): InvoiceSummaryData => {
  const total = (key: keyof ApiInvoiceRow) =>
    rows.reduce((sum, row) => sum + (Number(row[key]) || 0), 0);

  return {
    entries: rows.length,
    invoiced: total("invoice_amount"),
    collected: total("total_collected"),
    outstanding: total("outstanding"),
  };
};

export const BROKER_COUNTRY = INVOICE_LOCALISATION.brokerCountry;

export const TAX_RATE_PERCENT = INVOICE_LOCALISATION.taxRatePercent;

export const getInsurerCountryById = (insurerId?: string | number) =>
  INSURER_COUNTRY_BY_ID[String(insurerId ?? "")] || BROKER_COUNTRY;

const INSURER_COUNTRY_BY_ID: Record<string, string> = {
  "1": "United States",
  "2": "United Arab Emirates",
  "3": "United Arab Emirates",
  "4": "India",
  "5": "United Arab Emirates",
};

const getFiscalYearStart = (date: Date) =>
  date.getUTCMonth() >= 3 ? date.getUTCFullYear() : date.getUTCFullYear() - 1;

const toPeriodKey = (value?: string, granularity: InvoicePeriodGranularity = "monthly") => {
  if (!value) return "";

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";

  const year = parsed.getUTCFullYear();

  if (granularity === "yearly") {
    return `FY${getFiscalYearStart(parsed)}`;
  }

  if (granularity === "quarterly") {
    return `${year}-Q${Math.floor(parsed.getUTCMonth() / 3) + 1}`;
  }

  return `${year}-${String(parsed.getUTCMonth() + 1).padStart(2, "0")}`;
};

const toPeriodLabel = (periodKey: string) => {
  if (periodKey.startsWith("FY")) {
    const startYear = Number(periodKey.replace("FY", ""));
    return `FY ${startYear}-${String(startYear + 1).slice(-2)}`;
  }

  if (periodKey.includes("Q")) {
    const [year, quarter] = periodKey.split("-");
    return `${quarter} ${year}`;
  }

  const [year, month] = periodKey.split("-");
  const parsed = new Date(Number(year), Number(month) - 1, 1);

  return parsed.toLocaleDateString("en-GB", { month: "short", year: "numeric" });
};

export const getInvoiceInsurerOptions = (
  rows: ApiInvoiceRow[] = INVOICE_MOCK_ROWS
): InvoiceInsurerOption[] => {
  const byId = new Map<string, InvoiceInsurerOption>();

  rows.forEach((row) => {
    const value = String(row.insurer_id ?? "");
    if (!value || byId.has(value)) return;

    const name = row.insurer || "-";
    const country = INSURER_COUNTRY_BY_ID[value] || "-";

    byId.set(value, { value, label: `${name} — ${country}`, name, country });
  });

  return Array.from(byId.values());
};

export const getInvoicePeriodOptions = (
  granularity: InvoicePeriodGranularity,
  rows: ApiInvoiceRow[] = INVOICE_MOCK_ROWS
): InvoicePeriodOption[] => {
  const keys = new Set<string>();

  rows.forEach((row) => {
    const key = toPeriodKey(row.period_from, granularity);
    if (key) keys.add(key);
  });

  return Array.from(keys)
    .sort()
    .map((key) => ({ value: key, label: toPeriodLabel(key) }));
};

export const getDefaultPeriodForFilter = (
  filterType: string,
  options: InvoicePeriodOption[]
): string => {
  const now = new Date();
  const reference = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));

  if (filterType === "previous_month") {
    reference.setUTCMonth(reference.getUTCMonth() - 1);
  } else if (filterType === "previous_quarter") {
    reference.setUTCMonth(reference.getUTCMonth() - 3);
  } else if (filterType === "previous_fy") {
    reference.setUTCFullYear(reference.getUTCFullYear() - 1);
  }

  const key = toPeriodKey(reference.toISOString(), getPeriodGranularity(filterType));

  return options.some((option) => option.value === key) ? key : options[0]?.value || "";
};

export const getPendingInvoiceLineCount = (
  insurerId: string,
  period: string,
  granularity: InvoicePeriodGranularity,
  rows: ApiInvoiceRow[] = INVOICE_MOCK_ROWS
): number => {
  if (!insurerId || !period) return 0;

  return rows.filter(
    (row) =>
      String(row.insurer_id ?? "") === String(insurerId) &&
      toPeriodKey(row.period_from, granularity) === period
  ).length;
};

export const getInvoiceTaxSplit = (insurerCountry: string): InvoiceTaxSplit => {
  const { taxLabel, hasStateSplit } = INVOICE_LOCALISATION;
  const isCrossBorder = insurerCountry.trim().toLowerCase() !== BROKER_COUNTRY.trim().toLowerCase();

  const label = hasStateSplit
    ? isCrossBorder
      ? "IGST (cross-border)"
      : "CGST + SGST (domestic)"
    : `${taxLabel} (${isCrossBorder ? "cross-border" : "domestic"})`;

  return {
    brokerCountry: BROKER_COUNTRY,
    insurerCountry,
    isCrossBorder,
    taxLabel,
    label,
    ratePercent: TAX_RATE_PERCENT,
  };
};

export const buildInvoiceTaxBreakdown = (
  taxSplit: InvoiceTaxSplit,
  totalTax: number
): InvoiceTaxLine[] => {
  const { hasStateSplit } = INVOICE_LOCALISATION;
  const { ratePercent, isCrossBorder, taxLabel } = taxSplit;

  if (!hasStateSplit) {
    return [{ label: `${taxLabel} @ ${ratePercent}%`, amount: totalTax }];
  }

  if (isCrossBorder) {
    return [{ label: `IGST @ ${ratePercent}%`, amount: totalTax }];
  }

  const halfTax = round2(totalTax / 2);

  return [
    { label: `CGST @ ${ratePercent / 2}%`, amount: halfTax },
    { label: `SGST @ ${ratePercent / 2}%`, amount: round2(totalTax - halfTax) },
  ];
};

const BROKER_TAX_ID_BY_LOCALISATION: Record<string, string> = {
  IN: "08AABCN1234F1Z5",
  AE: "100123456700003",
};

export const BILLED_BY: InvoiceParty = {
  name: "NexInsure",
  country: BROKER_COUNTRY,
  taxId: BROKER_TAX_ID_BY_LOCALISATION[INVOICE_LOCALISATION.code] || "—",
  address: "New Ahinsapuri, Fatehpura, Udaipur, Rajasthan - 313001",
};

const DEFAULT_INSURER_BILLING: Pick<InvoiceParty, "taxId" | "address"> = {
  taxId: "29AAACA1234B1ZP",
  address: "12 MG Road, Bengaluru 560001",
};

const INSURER_BILLING_BY_ID: Record<string, Pick<InvoiceParty, "taxId" | "address">> = {
  "1": { taxId: "29AAACA1234B1ZP", address: "12 MG Road, Bengaluru 560001" },
  "2": { taxId: "100456789100003", address: "Sukoon Tower, Sheikh Zayed Road, Dubai" },
  "3": { taxId: "100789456200003", address: "Gulf Tower, Sheikh Zayed Road, Dubai" },
  "4": { taxId: "27AAACL7890D1ZR", address: "Prabhadevi Corporate Park, Mumbai 400025" },
  "5": { taxId: "100321654900003", address: "Al Nakheel, Ras Al Khaimah" },
};

const round2 = (value: number) => Math.round(value * 100) / 100;

const buildLineItems = (row: ApiInvoiceRow): InvoiceLineItem[] => {
  const totalCommission = Number(row.invoice_amount ?? row.commission) || 0;
  const ratePercent = Number(row.rate) || 10;
  const basePolicyNo = String(row.policy_no ?? "-");

  const variants = [
    { suffix: "", product: row.product || "-", customer: row.customer || "-", weight: 0.5 },
    { suffix: "-A", product: row.product || "-", customer: "meera joshi", weight: 0.3 },
    { suffix: "-B", product: row.product || "-", customer: "imran shaikh", weight: 0.2 },
  ];

  let allocated = 0;

  return variants.map((variant, index) => {
    const isLast = index === variants.length - 1;
    const commission = isLast
      ? round2(totalCommission - allocated)
      : round2(totalCommission * variant.weight);

    allocated = round2(allocated + commission);

    return {
      id: `${row.id ?? basePolicyNo}${variant.suffix || "-0"}`,
      policyNo: `${basePolicyNo}${variant.suffix}`,
      product: variant.product,
      customer: variant.customer,
      issueDate: row.issue_date || "",
      premium: ratePercent ? round2((commission * 100) / ratePercent) : 0,
      ratePercent,
      commission,
    };
  });
};

export const getInvoiceDetail = (row?: ApiInvoiceRow | null): InvoiceDetail | null => {
  if (!row) return null;

  const insurerId = String(row.insurer_id ?? "");
  const insurerCountry = getInsurerCountryById(insurerId);
  const taxSplit = getInvoiceTaxSplit(insurerCountry);

  const lineItems = buildLineItems(row);
  const taxableValue = round2(lineItems.reduce((sum, line) => sum + line.commission, 0));
  const totalTax = round2((taxableValue * taxSplit.ratePercent) / 100);

  const periodFrom = row.period_from || row.issue_date || "";
  const grandTotal = round2(taxableValue + totalTax);
  const isPaid = String(row.status ?? "").toUpperCase() === "PAID";
  const totalCollected =
    row.total_collected !== undefined ? Number(row.total_collected) || 0 : isPaid ? grandTotal : 0;

  return {
    invoiceNo: String(row.invoice_no ?? row.invoice ?? "-"),
    status: String(row.status ?? "UNBILLED").toUpperCase() as InvoiceDetail["status"],
    period: `${periodFrom}|${row.period_to || periodFrom}`,
    invoiceDate: row.issue_date || "",
    dueDate: row.due_date || "",
    billedBy: BILLED_BY,
    billedTo: {
      name: row.insurer || "-",
      country: insurerCountry,
      taxId: INSURER_BILLING_BY_ID[insurerId]?.taxId || DEFAULT_INSURER_BILLING.taxId,
      address: INSURER_BILLING_BY_ID[insurerId]?.address || DEFAULT_INSURER_BILLING.address,
    },
    lineItems,
    taxSplit,
    taxableValue,
    taxBreakdown: buildInvoiceTaxBreakdown(taxSplit, totalTax),
    totalTax,
    grandTotal,
    totalCollected,
    outstanding:
      row.outstanding !== undefined
        ? Number(row.outstanding) || 0
        : Math.max(round2(grandTotal - totalCollected), 0),
  };
};
